import React, { useState, useEffect, useContext } from 'react';
import AdminContext from '../../../StateContext/Application';

const Ulb = () => {
    const context = useContext(AdminContext);
    const { GetAllUlb } = context;

    const [project, setProjectList] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;

    const getUlbList = async () => {
        let data = await GetAllUlb();
        console.log("data", data);
        setProjectList(data);
        setFilteredBills(data);
    };

    useEffect(() => {
        getUlbList();
    }, []);

    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = project.filter((bill) =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, project]);

    const totalPages = Math.ceil(filteredBills.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);

    return (
        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "78vw", marginBottom: "15px" }}>
                <h4 style={{ margin: "10px" }}>ULB List</h4>
                <input
                    type="text"
                    placeholder="Search"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    style={{
                        width: "250px",
                        padding: "8px 12px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        backgroundColor: 'aliceblue',
                        fontSize: "14px",
                        marginRight: "10px"
                    }}
                />
            </div>
            <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%" }}>
                <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                    <table style={{ width: '100%', borderCollapse: "collapse", minWidth: "1200px" }}>
                        <thead>
                            <tr style={{ color: 'white', height: '3.5rem' }}>
                                <th>sr.no</th>
                                <th style={{ padding: '8px' }}>ULBCode</th>
                                <th style={{ padding: '8px' }}>Region</th>
                                <th style={{ padding: '8px' }}>District</th>
                                <th style={{ padding: '8px' }}>ULBName</th>
                                <th style={{ padding: '8px' }}>Population</th>
                                <th style={{ padding: '8px' }}>Class</th>
                                <th style={{ padding: '8px' }}>EMailID</th>
                                <th style={{ padding: '8px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentBills?.length === 0 ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                        No data available
                                    </td>
                                </tr>
                            ) : (currentBills.map((project, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tr key={project.ULBCode} style={{ backgroundColor: bgColor, borderBottom: '1px solid #3b409e' }}>
                                        <td style={{ padding: '8px' }}>{index + 1}</td>
                                        <td style={{ padding: '8px' }}>{project.ULBCode}</td>
                                        <td style={{ padding: '8px' }}>{project.Region}</td>
                                        <td style={{ padding: '8px' }}>{project.District}</td>
                                        <td style={{ padding: '8px' }}>{project.ULBName}</td>
                                        <td style={{ padding: '8px' }}>{project.Population}</td>
                                        <td style={{ padding: '8px' }}>{project.Class}</td>
                                        <td style={{ padding: '8px' }}>{project.EMailID}</td>
                                        <td>
                                            <button>Edit</button>
                                        </td>
                                    </tr>
                                );
                            })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 2.5rem', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>Showing {currentBills.length} of {project.length} entries</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>
                        {currentPage}
                    </button>
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Ulb;
